export default __webpack_public_path__ + "static/media/BTR-BUSD.216b112d.svg";